const getters = {
  getConversations($state) {
    return [...$state.conversations].sort(
      (a, b) => new Date(b.last_activity_at) - new Date(a.last_activity_at)
    );
  },
  getConversationById: $state => conversationId => {
    return $state.conversations.find(
      conversation => Number(conversation.id) === Number(conversationId)
    );
  },
  getActiveConversationId($state) {
    return $state.activeConversationId;
  },
  getActiveConversation($state, $getters) {
    return $getters.getConversationById($state.activeConversationId);
  },
  getMessagesByConversationId: $state => conversationId => {
    return $state.messagesByConversationId[conversationId] || [];
  },
  getTotalUnreadCount($state) {
    return $state.conversations.reduce(
      (total, conversation) => total + (conversation.unread_count || 0),
      0
    );
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export default getters;
